import { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

// Antd Components
import { Button, Input, InputNumber, Modal, Table, Tag } from "antd";
import { Big } from "bigdecimal.js"; // to avoid decimals wrrors
import Toggle from "../common/Toggle";
import CustomPaymentModal from "./CustomPaymentModal";

import { DeleteOutlined } from "@ant-design/icons";
import { offlinePaymentMethods } from "../util";
const { Column } = Table;

class SplitPaymentModal extends Component {
  state = {
    payments: this.props.payments,
    customPaymentModallVisible: false,
    customPaymentType: null,
  };

  getPaid = () => {
    const { payments } = this.state;

    const paidAmount = payments
      .reduce((sum, p) => sum.add(Number(p.amount?.toFixed?.(6)) || 0), Big(0))
      .numberValue();

    return paidAmount;
  };

  getRemaining = () => {
    const { orderTotal, actualOrderTotal } = this.props;

    return Number(Big(actualOrderTotal ?? orderTotal).subtract(this.getPaid()));
  };

  getOrderStatus = () => {
    const { orderTotal } = this.props;
    const paid = this.getPaid();
    const total = orderTotal;

    if (paid === 0) return "Unpaid";
    if (paid < total) return "Partially Paid";
    return "Paid";
  };

  addPayment = (method, payment_ctype, reference, isReturn = false) => {
    const { customer, manuallyAppliedPromotion, settings } = this.props;
    const remaining = this.getRemaining();

    let amount = remaining > 0 || isReturn ? remaining : 0;

    if (amount === 0) return;

    if (method === "wallet") {
      amount = Math.min(amount, customer?.userDetails?.wallet);
    } else if (method === "loyalty points") {
      const avaialblePoints =
        customer?.userDetails?.points -
        (manuallyAppliedPromotion?.loyaltyPointsCost || 0);

      const loyaltyPointsMoneyValue =
        Math.floor(
          avaialblePoints / settings.loyalty_points_to_money_threshold,
        ) * settings.loyalty_points_to_money_conversion_rate;

      if (loyaltyPointsMoneyValue < 0) return;
      amount = Math.min(amount, loyaltyPointsMoneyValue);
    }

    this.setState({
      payments: [
        ...this.state.payments,
        {
          payment_method: method,
          amount: amount,
          payment_complete: true,
          payment_reference: reference,
          payment_ctype: isReturn ? "return" : payment_ctype,
        },
      ],
    });
  };

  updatePayment = (index, value, field) => {
    const payments = [...this.state.payments];
    const { customer, manuallyAppliedPromotion, settings } = this.props;
    let payment = { ...payments[index] };
    if (field === "amount") {
      if (payments[index]["payment_method"] == "loyalty points") {
        const avaialblePoints =
          customer?.userDetails?.points -
          (manuallyAppliedPromotion?.loyaltyPointsCost || 0);

        let loyaltyPointsMoneyValue =
          Math.floor(
            avaialblePoints / settings.loyalty_points_to_money_threshold,
          ) * settings.loyalty_points_to_money_conversion_rate;

        if (payment.id) {
          loyaltyPointsMoneyValue += payment.default_amount;
        }
        console.log(loyaltyPointsMoneyValue, "qwe");
        value = Math.min(loyaltyPointsMoneyValue, value);
      } else if (payments[index]["payment_method"] == "wallet") {
        let CustomerWallet = customer?.userDetails?.wallet || 0;
        if (payment.id) {
          CustomerWallet += payment.default_amount;
        }
        value = Math.min(CustomerWallet, value);
      }
    }

    payment[field] = value;
    payments[index] = payment;

    this.setState({ payments });
  };

  removePayment = (index) => {
    const payments = [...this.state.payments];
    payments.splice(index, 1);

    this.setState({ payments });
  };

  renderStatusTag = () => {
    const { t, config, settings } = this.props;
    const remaining = this.getRemaining();
    const currencey =
      config.language === "arabic"
        ? settings.currency_local
        : settings.currency_english;

    if (remaining < 0)
      return (
        <Tag color="red">
          {t("you need to remove")}{" "}
          {Math.abs(remaining).toFixed(settings.currency_decimals)} {currencey}
        </Tag>
      );

    if (remaining > 0)
      return (
        <Tag color="orange">
          {t("you need to add")} {remaining.toFixed(settings.currency_decimals)}{" "}
          {currencey}
        </Tag>
      );
  };

  saveButtonDisabled = () => {
    const { payments } = this.state;
    const remaining = this.getRemaining();

    return remaining != 0 || payments.some((p) => p.amount == 0 && !p.id);
  };
  loyaltyPaymentDisabled = () => {
    const { payments } = this.state;
    const { customer, settings, manuallyAppliedPromotion } = this.props;
    if (payments.some((p) => p.payment_method === "loyalty points")) {
      return true;
    }

    const avaialblePoints =
      customer?.userDetails?.points -
      (manuallyAppliedPromotion?.loyaltyPointsCost || 0);

    const loyaltyPointsMoneyValue =
      Math.floor(avaialblePoints / settings.loyalty_points_to_money_threshold) *
      settings.loyalty_points_to_money_conversion_rate;

    if (loyaltyPointsMoneyValue <= 0) return true;

    return false;
  };

  render() {
    const {
      visible,
      t,
      config,
      orderTotal,
      settings,
      customer,
      manuallyAppliedPromotion,

      totalPaid,
      isReturningPayment,
      isEditingOrder,
      actualOrderTotal,
    } = this.props;
    const { payments, customPaymentModallVisible, customPaymentType } =
      this.state;
    const avaialblePoints =
      customer?.userDetails?.points -
      (manuallyAppliedPromotion?.loyaltyPointsCost || 0);

    const currencey =
      config.language === "arabic"
        ? settings.currency_local
        : settings.currency_english;

    const remaining = this.getRemaining();
    return (
      <Modal
        style={{ top: 20 }}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {isEditingOrder || actualOrderTotal !== null
              ? t("Manage Payments")
              : t("Split Payments")}
          </div>
        }
        visible={visible}
        onCancel={() => {
          this.props.onClose();
        }}
        onOk={() => {
          this.props.onClose(payments);
        }}
        okButtonProps={{
          disabled: this.saveButtonDisabled(),
        }}
        cancelButtonProps={{
          className: "float-left",
          danger: true,
          hidden: isEditingOrder,
          onClick: () => {
            this.props.onResetPayments();
            this.props.onClose();
          },
        }}
        okText={t("Save")}
        cancelText={t("Cancel")}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
      >
        <div className={"mt-3"}>
          {customPaymentModallVisible && (
            <CustomPaymentModal
              visible={customPaymentModallVisible}
              onClose={(paymentMethod, paymentReference) => {
                if (paymentMethod) {
                  this.addPayment(
                    "custom",
                    paymentMethod,
                    paymentReference,
                    customPaymentType === "return",
                  );
                }
                this.setState({
                  customPaymentModallVisible: false,
                  customPaymentType: null,
                });
              }}
            />
          )}

          <div style={{ marginBottom: 20 }}>
            {actualOrderTotal != null && (
              <Tag
                style={{ marginBottom: 5 }}
                color="red"
              >{`Prices changed after order was placed.`}</Tag>
            )}
            <div>
              <b>{t("Total")}:</b>{" "}
              {(actualOrderTotal ?? orderTotal).toFixed(
                settings.currency_decimals,
              )}{" "}
              {currencey}
            </div>

            <div>
              <b>{t("Marked for payment")}:</b>{" "}
              {this.getPaid().toFixed(settings.currency_decimals)} {currencey}
            </div>

            <div>
              <b>{t("Remaining")}:</b>{" "}
              {remaining.toFixed(settings.currency_decimals)} {currencey}
            </div>

            <div style={{ marginTop: 5 }}>{this.renderStatusTag()}</div>
          </div>

          {/* Payment Buttons */}
          <div className="mt-0 mb-0">
            <p style={{ fontSize: 15 }}>{t("Add a payment")}</p>
            <div
              style={{
                marginBottom: 20,
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              {settings.enable_cash_for_pos && (
                <Button
                  disabled={remaining <= 0}
                  onClick={() => this.addPayment("cash")}
                >
                  {t("Cash")}
                </Button>
              )}

              {settings.enable_online_payments_for_pos && (
                <Button
                  disabled={remaining <= 0}
                  onClick={() => this.addPayment("online")}
                >
                  {t("Online")}
                </Button>
              )}

              {settings.enable_wallet &&
                settings.enable_wallet_staff &&
                customer?.userID && (
                  <Button
                    onClick={() => this.addPayment("wallet")}
                    disabled={
                      remaining <= 0 ||
                      payments.some((p) => p.payment_method === "wallet") ||
                      customer?.userDetails?.wallet <= 0
                    }
                  >
                    {`${t("Wallet")} (${customer?.userDetails?.wallet.toFixed(
                      settings.currency_decimals,
                    )} ${currencey})`}
                  </Button>
                )}

              {settings.enable_loyalty_points &&
                settings.enable_loyalty_points_staff &&
                settings.enable_loyalty_points_payment &&
                customer?.userID &&
                avaialblePoints > 0 && (
                  <Button
                    onClick={() => this.addPayment("loyalty points")}
                    disabled={remaining <= 0 || this.loyaltyPaymentDisabled()}
                  >
                    {`${t("Loyalty Points")} (${avaialblePoints})`}
                  </Button>
                )}
              {settings.enable_custom_payments_for_pos && (
                <Button
                  disabled={remaining <= 0}
                  onClick={() =>
                    this.setState({ customPaymentModallVisible: true })
                  }
                >
                  {t("Custom")}
                </Button>
              )}
            </div>
          </div>

          {/* returns */}
          {isReturningPayment && (
            <div className="mt-0 mb-0">
              <p style={{ fontSize: 15 }}>{t("Add a return")}</p>
              <div
                style={{
                  marginBottom: 20,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                }}
              >
                {settings.enable_cash_for_pos && (
                  <Button
                    disabled={remaining >= 0}
                    onClick={() => this.addPayment("cash", null, null, true)}
                  >
                    {t("Cash")}
                  </Button>
                )}

                {settings.enable_online_payments_for_pos && (
                  <Button
                    disabled={remaining >= 0}
                    onClick={() => this.addPayment("online", null, null, true)}
                  >
                    {t("Online")}
                  </Button>
                )}

                {settings.enable_wallet &&
                  settings.enable_wallet_staff &&
                  customer?.userID && (
                    <Button
                      onClick={() =>
                        this.addPayment("wallet", null, null, true)
                      }
                      disabled={
                        remaining >= 0 ||
                        // payments.some((p) => p.payment_method === "wallet") ||
                        customer?.userDetails?.wallet <= 0
                      }
                    >
                      {`${t("Wallet")} (${customer?.userDetails?.wallet.toFixed(
                        settings.currency_decimals,
                      )} ${currencey})`}
                    </Button>
                  )}

                {settings.enable_custom_payments_for_pos && (
                  <Button
                    disabled={remaining >= 0}
                    onClick={() =>
                      this.setState({
                        customPaymentModallVisible: true,
                        customPaymentType: "return",
                      })
                    }
                  >
                    {t("Custom")}
                  </Button>
                )}
              </div>
            </div>
          )}

          <Table
            dataSource={this.state.payments}
            size="small"
            pagination={false}
            rowKey={(r, i) => i}
          >
            <Column
              title={t("Type")}
              render={(record, index) =>
                record.amount < 0 ? t("Return") : t("Payment")
              }
            />
            <Column
              title={t("Method")}
              dataIndex="payment_method"
              render={(text, record, index) =>
                text === "custom" ? t(record.payment_ctype) : t(text)
              }
            />
            <Column
              title={t("Amount")}
              render={(text, record, index) => (
                <InputNumber
                  disabled={
                    record.id &&
                    !offlinePaymentMethods.includes(record.payment_method) // temporarly
                  }
                  value={record.amount}
                  onChange={(e) =>
                    this.updatePayment(index, Number(e), "amount")
                  }
                />
              )}
            />
            <Column
              title={t("Paid")}
              render={(text, record, index) => (
                <div>
                  <Toggle
                    disabled={
                      (record.id &&
                        !offlinePaymentMethods.includes(
                          record.payment_method,
                        )) ||
                      record.payment_ctype === "return" ||
                      ["wallet", "loyalty points"].includes(
                        record.payment_method,
                      )
                    }
                    isActive={
                      record.payment_complete ||
                      record.payment_ctype === "return"
                    }
                    onClick={() =>
                      this.updatePayment(
                        index,
                        !record.payment_complete,
                        "payment_complete",
                      )
                    }
                  />
                </div>
              )}
            />
            <Column
              title={t("Reference")}
              render={(text, record, index) => (
                <Input
                  disabled={
                    record.id &&
                    !offlinePaymentMethods.includes(record.payment_method)
                  }
                  value={record.payment_reference}
                  onChange={(e) =>
                    this.updatePayment(
                      index,
                      e.target.value,
                      "payment_reference",
                    )
                  }
                />
              )}
            />

            <Column
              title={t("Delete")}
              render={(text, record, index) => (
                <Button
                  disabled={record.id}
                  danger
                  onClick={() => this.removePayment(index)}
                  shape="circle"
                  icon={<DeleteOutlined style={{ top: 0 }} />}
                ></Button>
              )}
            />
          </Table>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
    paymentMethods: state.pos.paymentMethods,
    permissions: state.auth.permissions,
    customer: state.pos.customer,
    manuallyAppliedPromotion: state.pos.manuallyAppliedPromotion,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(SplitPaymentModal));
